import React from 'react'
import HeroSection from '../components/home/HeroSection'
import CategorySection from '../components/home/CategorySection'
import FeaturedProducts from '../components/home/FeaturedProducts'
import WhyChooseSection from '../components/home/WhyChooseUs'
import HowItWorksSection from '../components/home/HowItWorksSection'
import HealthTipsSection from '../components/home/HealthTipsSection'
import CTASection from '../components/home/CTASection'


function Home() {
  return (
    <>
    <HeroSection/>
    <CategorySection/>
    <FeaturedProducts/>
    <WhyChooseSection/>
    <HealthTipsSection/>
    <HowItWorksSection/>
    <CTASection/>
    </>
  )
}

export default Home